<template>
  <div class="d-flex flex-column">
    <div v-if="$_can('jobs.system.logs.index')" class="d-flex align-items-center justify-content-end">
      <button class="btn btn-change" @click.prevent="showSystemLogs = !showSystemLogs">
        {{ showSystemLogs ? 'Back to regular logs' : 'View system logs' }}
      </button>
    </div>
    <template v-if="showSystemLogs && $_can('jobs.system.logs.index')">
      <log :model="job" type="jobs" />
    </template>
    <template v-else>
      <template v-if="!logs">
        <vue-content-loading :width="800" :height="450">
          <rect v-for="x in 15" :key="x" x="10" :y="15*x*1.4" rx="5" ry="5" width="720" height="6" />
        </vue-content-loading>
      </template>
      <template>
        <div id="accordion" class="log-wrap mb-3">
          <div v-for="log in logs"
               :key="log.id"
          >
            <template v-if="log.type === 'job_created'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Move booked</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Move date:</td>
                          <td>{{ log.data.move_date }}</td>
                        </tr>
                        <tr>
                          <td>Movers:</td>
                          <td>{{ log.data.movers }}</td>
                        </tr>
                        <tr>
                          <td>Trucks:</td>
                          <td>{{ log.data.trucks }}</td>
                        </tr>
                        <tr>
                          <td>Move size:</td>
                          <td>{{ log.data.move_size }}</td>
                        </tr>
                        <tr>
                          <td>Arrival window:</td>
                          <td>{{ log.data.arrival_window }}</td>
                        </tr>
                        <tr>
                          <td>Cash discount:</td>
                          <td>{{ log.data.cash_discount }}</td>
                        </tr>
                        <tr>
                          <td>Min horus:</td>
                          <td>{{ log.data.minimum_hours }}</td>
                        </tr>
                        <tr>
                          <td>Deposit:</td>
                          <td>{{ log.data.deposit }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="log.type === 'job_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">{{ getJobUpdatedTitle(log) }}</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="log.data.old_move_date || log.data.new_move_date">
                          <td>Move date:</td>
                          <td>{{ log.data.old_move_date }}</td>
                          <td>{{ log.data.new_move_date }}</td>
                        </tr>
                        <tr v-if="log.data.new_movers || log.data.old_movers">
                          <td>Movers:</td>
                          <td>{{ log.data.old_movers }}</td>
                          <td>{{ log.data.new_movers }}</td>
                        </tr>
                        <tr v-if="log.data.old_trucks || log.data.new_trucks">
                          <td>Trucks:</td>
                          <td>{{ log.data.old_trucks }}</td>
                          <td>{{ log.data.new_trucks }}</td>
                        </tr>
                        <tr v-if="log.data.old_move_size || log.data.new_move_size">
                          <td>Move size:</td>
                          <td>{{ log.data.old_move_size }}</td>
                          <td>{{ log.data.new_move_size }}</td>
                        </tr>
                        <tr v-if="log.data.old_arrival_window || log.data.new_arrival_window">
                          <td>Arrival window:</td>
                          <td>{{ log.data.old_arrival_window }}</td>
                          <td>{{ log.data.new_arrival_window }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'offer_created'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Custom rate created for the move {{ log.data.ref }}</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Move date:</td>
                          <td>{{ log.data.move_date }}</td>
                        </tr>
                        <tr>
                          <td>Movers:</td>
                          <td>{{ log.data.movers }}</td>
                        </tr>
                        <tr>
                          <td>Trucks:</td>
                          <td>{{ log.data.trucks }}</td>
                        </tr>
                        <tr>
                          <td>Rate:</td>
                          <td>{{ log.data.rate }}</td>
                        </tr>
                        <tr>
                          <td>Deposit:</td>
                          <td>{{ log.data.deposit }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'offer_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Custom rate saved for the move {{ log.data.ref }}</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Move date:</td>
                          <td>{{ log.data.move_date }}</td>
                        </tr>
                        <tr>
                          <td>Movers:</td>
                          <td>{{ log.data.movers }}</td>
                        </tr>
                        <tr>
                          <td>Trucks:</td>
                          <td>{{ log.data.trucks }}</td>
                        </tr>
                        <tr>
                          <td>Rate:</td>
                          <td>{{ log.data.rate }}</td>
                        </tr>
                        <tr>
                          <td>Deposit:</td>
                          <td>{{ log.data.deposit }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'offer_deleted'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Offer deleted for the move {{ log.data.ref }}</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Move date:</td>
                          <td>{{ log.data.move_date }}</td>
                        </tr>
                        <tr>
                          <td>Movers:</td>
                          <td>{{ log.data.movers }}</td>
                        </tr>
                        <tr>
                          <td>Trucks:</td>
                          <td>{{ log.data.trucks }}</td>
                        </tr>
                        <tr>
                          <td>Rate:</td>
                          <td>{{ log.data.rate }}</td>
                        </tr>
                        <tr>
                          <td>Deposit:</td>
                          <td>{{ log.data.deposit }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'expense_created'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">{{ log.data.name }} of ${{ log.data.amount }} added</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td>{{ log.data.name }}</td>
                        </tr>
                        <tr>
                          <td>Amount:</td>
                          <td>$ {{ log.data.amount }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'expense_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">{{ log.data.name }} of ${{ log.data.amount }} updated</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="log.data.old_amount || log.data.new_amount">
                          <td>Amount:</td>
                          <td>{{ log.data.old_amount ? '$ '+log.data.old_amount : '' }}</td>
                          <td>{{ log.data.new_amount ? '$ '+log.data.new_amount : '' }}</td>
                        </tr>
                        <tr v-if="log.data.old_name || log.data.new_name">
                          <td>Name:</td>
                          <td>{{ log.data.old_name }}</td>
                          <td>{{ log.data.new_name }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'discount_created'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Discount of {{ log.data.amount }} added</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td>{{ log.data.name }}</td>
                        </tr>
                        <tr>
                          <td>Amount:</td>
                          <td>{{ log.data.amount }}</td>
                        </tr>
                        <tr>
                          <td>Type:</td>
                          <td>{{ log.data.type }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'discount_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Discount of {{ log.data.amount }} updated</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="log.data.new_name || log.data.old_name">
                          <td>Name: </td>
                          <td>{{ log.data.old_name }}</td>
                          <td>{{ log.data.new_name }}</td>
                        </tr>
                        <tr v-if="log.data.old_amount || log.data.new_amount">
                          <td>Amount: </td>
                          <td>{{ log.data.old_amount }}</td>
                          <td>{{ log.data.new_amount }}</td>
                        </tr>
                        <tr v-if="log.data.new_type || log.data.old_type">
                          <td>Type: </td>
                          <td>{{ log.data.old_type }}</td>
                          <td>{{ log.data.new_type }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'discount_deleted'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Discount of {{ log.data.amount }} deleted</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Name:</td>
                          <td>{{ log.data.name }}</td>
                        </tr>
                        <tr>
                          <td>Amount:</td>
                          <td>{{ log.data.amount }}</td>
                        </tr>
                        <tr>
                          <td>Type:</td>
                          <td>{{ log.data.type }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'address_created'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Address created</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Type:</td>
                          <td>{{ log.data.type }}</td>
                        </tr>
                        <tr>
                          <td>Full address:</td>
                          <td>{{ log.data.full_address }}</td>
                        </tr>
                        <tr>
                          <td>Floor:</td>
                          <td>{{ log.data.floor }}</td>
                        </tr>
                        <tr>
                          <td>Apartment:</td>
                          <td>{{ log.data.apartment }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'address_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Address updated</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="log.data.old_type || log.data.new_type">
                          <td>Type:</td>
                          <td>{{ log.data.old_type }}</td>
                          <td>{{ log.data.new_type }}</td>
                        </tr>
                        <tr v-if="log.data.old_floor || log.data.new_floor">
                          <td>Floor:</td>
                          <td>{{ log.data.old_floor }}</td>
                          <td>{{ log.data.new_floor }}</td>
                        </tr>
                        <tr v-if="log.data.old_full_address || log.data.new_full_address">
                          <td>Full address:</td>
                          <td>{{ log.data.old_full_address }}</td>
                          <td>{{ log.data.new_full_address }}</td>
                        </tr>
                        <tr v-if="log.data.old_apartment || log.data.new_apartment">
                          <td>Apartment:</td>
                          <td>{{ log.data.old_apartment }}</td>
                          <td>{{ log.data.new_apartment }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'address_deleted'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Address deleted</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Type:</td>
                          <td>{{ log.data.type }}</td>
                        </tr>
                        <tr>
                          <td>Full address:</td>
                          <td>{{ log.data.full_address }}</td>
                        </tr>
                        <tr>
                          <td>Floor:</td>
                          <td>{{ log.data.floor }}</td>
                        </tr>
                        <tr>
                          <td>Apartment:</td>
                          <td>{{ log.data.apartment }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'time_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Move duration changed to {{ log.data.new_time }}</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Job time:</td>
                          <td>{{ log.data.old_time }}</td>
                          <td>{{ log.data.new_time }}</td>
                        </tr>
                        <tr>
                          <td>Job total hours overridden:</td>
                          <td>{{ log.data.job_total_hours_overridden ? 'Yes' : 'No' }}</td>
                          <td />
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'double_drive_time_changed'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Double drive time changed to {{ log.data.new_time }}</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="log.data.old_time || log.data.new_time">
                          <td>DDT:</td>
                          <td>{{ log.data.old_time }}</td>
                          <td>{{ log.data.new_time }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'update_is_small'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Job size changed to <b>{{ log.data.new_value }}</b></p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Job size:</td>
                          <td>{{ log.data.old_value }}</td>
                          <td>{{ log.data.new_value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'status_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Job status updated to {{ log.data.new_status }}</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Status:</td>
                          <td>{{ log.data.old_status }}</td>
                          <td>{{ log.data.new_status }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'assign_carriers'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Job assigned to carrier: {{ log.data.new_carrier }}</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Carrier:</td>
                          <td>{{ log.data.old_carrier }}</td>
                          <td>{{ log.data.new_carrier }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'assign_movers'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">
                      Mover(s) assignment changed
                    </p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr v-if="log.data.assigned_foreman">
                          <td>Assigned foreman:</td>
                          <td>{{ log.data.assigned_foreman }}</td>
                        </tr>
                        <tr>
                          <td>Assigned movers:</td>
                          <td>{{ log.data.assigned_movers }}<template v-if="log.data.removed_movers"><template v-if="log.data.assigned_movers">, </template><span class="removed-movers-trucks">{{ log.data.removed_movers }}</span></template> </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'assign_trucks'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Truck(s) assignment changed</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Assigned trucks:</td>
                          <td>{{ log.data.assigned_trucks }}<template v-if="log.data.removed_trucks"><template v-if="log.data.assigned_trucks">, </template><span class="removed-movers-trucks">{{ log.data.removed_trucks }}</span></template> </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'charge_created'">
              <div class="row align-items-center log-box collapsed d-flex"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">{{ log.data.payment_type }} of ${{ log.data.amount }} created</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Amount:</td>
                          <td>$ {{ log.data.amount }}</td>
                        </tr>
                        <tr>
                          <td>Note:</td>
                          <td>{{ log.data.note }}</td>
                        </tr>
                        <tr v-if="log.data.charge_fee">
                          <td>Charge fee:</td>
                          <td>{{ log.data.charge_fee }}</td>
                        </tr>
                        <tr>
                          <td>Payment method:</td>
                          <td>{{ log.data.payment_method }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'charge_deleted'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">{{ log.data.payment_type }} of ${{ log.data.amount }} deleted</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Amount:</td>
                          <td>${{ log.data.amount }}</td>
                        </tr>
                        <tr>
                          <td>Note:</td>
                          <td>{{ log.data.note }}</td>
                        </tr>
                        <tr v-if="log.data.charge_fee">
                          <td>Charge fee:</td>
                          <td>{{ log.data.charge_fee }}</td>
                        </tr>
                        <tr>
                          <td>Payment method:</td>
                          <td>{{ log.data.payment_method }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'charge_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">{{ log.data.payment_type }} of ${{ log.data.new_amount }} updated</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="log.data.old_amount || log.data.new_amount">
                          <td>Amount:</td>
                          <td>{{ log.data.old_amount ? '$ '+log.data.old_amount : '' }}</td>
                          <td>{{ log.data.new_amount ? '$ '+log.data.new_amount : '' }}</td>
                        </tr>
                        <tr v-if="log.data.old_charge_fee || log.data.new_charge_fee">
                          <td>Charge fee:</td>
                          <td>{{ log.data.old_charge_fee ? '$ '+log.data.old_charge_fee : '' }}</td>
                          <td>{{ log.data.new_charge_fee ? '$ '+log.data.new_charge_fee : '' }}</td>
                        </tr>
                        <tr v-if="log.data.old_note || log.data.new_note">
                          <td>Note:</td>
                          <td>{{ log.data.old_note }}</td>
                          <td>{{ log.data.new_note }}</td>
                        </tr>
                        <tr v-if="log.data.old_payment_method || log.data.new_payment_method">
                          <td>Payment method:</td>
                          <td>{{ log.data.old_payment_method }}</td>
                          <td>{{ log.data.new_payment_method }}</td>
                        </tr>
                        <tr v-if="log.data.old_payment_type || log.data.new_payment_type">
                          <td>Payment type:</td>
                          <td>{{ log.data.old_payment_type }}</td>
                          <td>{{ log.data.new_payment_type }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'assign_user'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">User {{ log.data.new_user }} assigned to the job</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Assigned user:</td>
                          <td>{{ log.data.old_user }}</td>
                          <td>{{ log.data.new_user }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'send_pre_agreement'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Pre agreement contract sent to the customer</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id" data-parent="#accordion" />
            </template>
            <template v-else-if="log.type === 'job_updates_email_sent'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Email with updates sent to customer</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr v-for="(change, index) in log.data" :key="index">
                          <td>{{ change }}</td>
                          <td />
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'customer_note_created'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Customer note created</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Note:</td>
                          <td>{{ log.data.value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'customer_note_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Customer note updated</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Note:</td>
                          <td>{{ log.data.old_value }}</td>
                          <td>{{ log.data.new_value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'customer_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Customer updated</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="log.data.old_email || log.data.new_email">
                          <td>Email:</td>
                          <td>{{ log.data.old_email }}</td>
                          <td>{{ log.data.new_email }}</td>
                        </tr>
                        <tr v-if="log.data.old_first_name || log.data.new_first_name">
                          <td>First name:</td>
                          <td>{{ log.data.old_first_name }}</td>
                          <td>{{ log.data.new_first_name }}</td>
                        </tr>
                        <tr v-if="log.data.old_last_name || log.data.new_last_name">
                          <td>Last name:</td>
                          <td>{{ log.data.old_last_name }}</td>
                          <td>{{ log.data.new_last_name }}</td>
                        </tr>
                        <tr v-if="log.data.old_phone || log.data.new_phone">
                          <td>Phone:</td>
                          <td>{{ log.data.old_phone }}</td>
                          <td>{{ log.data.new_phone }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'claim_created'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Claim created</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>Ref:</td>
                          <td>{{ log.data.ref_id }}</td>
                        </tr>
                        <tr>
                          <td>Claim type:</td>
                          <td>{{ log.data.claim_type }}</td>
                        </tr>
                        <tr>
                          <td>Claim priority:</td>
                          <td>{{ log.data.claim_priority }}</td>
                        </tr>
                        <tr>
                          <td>Title:</td>
                          <td>{{ log.data.title }}</td>
                        </tr>
                        <tr>
                          <td>Description:</td>
                          <td>{{ log.data.description }}</td>
                        </tr>
                        <tr>
                          <td>Assigned to:</td>
                          <td>{{ log.data.assigned_to }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="log.type === 'address_note_updated'">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">Locations note updated</p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <thead>
                        <tr>
                          <th />
                          <th>Old value:</th>
                          <th>New value:</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-if="log.data.old_value || log.data.new_value">
                          <td>Note:</td>
                          <td>{{ log.data.old_value }}</td>
                          <td>{{ log.data.new_value }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="(log.type === 'job_file_uploaded' || log.type === 'job_file_updated' || log.type === 'job_file_deleted')">
              <div class="row align-items-center log-box collapsed"
                   :id="'heading-' + log.id"
                   data-toggle="collapse" data-parent="#accordion"
                   :data-target="'#collapse-' + log.id"
                   :aria-controls="'#collapse-' + log.id"
              >
                <div class="col-1 circle-border-line d-none d-lg-block d-xl-block d-md-block">
                  <i class="fa fa-circle-thin" />
                </div>
                <div class="col-11 d-flex align-items-center justify-content-between flex-row">
                  <div class="log-description">
                    <p class="mb-0 log-description">
                      <template v-if="log.type === 'job_file_uploaded'">
                        File uploaded
                      </template>
                      <template v-else-if="log.type === 'job_file_updated'">
                        File updated
                      </template>
                      <template v-else>
                        File deleted
                      </template>
                    </p>
                    <p class="mb-0 log-date">{{ log.created_at }} | {{ log.done_by }}</p>
                  </div>
                  <div class="">
                    <span class="mod-icon-plus" />
                    <span class="mod-icon-minus" />
                  </div>
                </div>
              </div>
              <div :id="'collapse-' + log.id" class="collapse" aria-expanded="false" :aria-labelledby="'heading-' + log.id"
                   data-parent="#accordion"
              >
                <div class="row">
                  <div class="col-1 d-none d-lg-block d-xl-block d-md-block" />
                  <div class="col-11 pt-3">
                    <table class="table m-table table-hover log-table">
                      <tbody>
                        <tr>
                          <td>File name:</td>
                          <td>{{ log.data.name }}</td>
                        </tr>
                        <tr>
                          <td>Visible to customer:</td>
                          <td>{{ log.data.can_see_customer || log.data.uploaded_by_customer ? 'Yes' : 'No' }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import axios from 'axios';
import Log from '../ModelLog';

export default {
  name: 'JobLogs',
  components: { Log },
  props: {
    job: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    logs: [],
    showSystemLogs: false,
  }),
  mounted() {
    this.getLogs();
  },
  methods: {
    getLogs() {
      axios
        .get(`/jobs/${this.job.id}/activity/logs`)
        .then(res => {
          this.logs = res.data.data;
        })
        .catch(err => console.log(err));
    },
    getJobUpdatedTitle(log) {
      const fields = ['move_date', 'movers', 'trucks', 'move_size', 'arrival_window'];
      const updates = [];
      fields.forEach(field => {
        if (
          typeof log.data[`new_${field}`] !== 'undefined' &&
          typeof log.data[`old_${field}`] !== 'undefined'
        ) {
          updates.push(field);
        }
      });

      if (updates.length !== 1) {
        return 'Job move info updated';
      }

      const update = updates[0];

      if (update === 'move_size') {
        return `Job move info updated - Move size changed to ${log.data.new_move_size}`;
      }

      if (update === 'movers') {
        return `Job move info updated - Movers number changed to ${log.data.new_movers}`;
      }

      if (update === 'trucks') {
        return `Job move info updated - Trucks number changed to ${log.data.new_trucks}`;
      }

      if (update === 'move_date') {
        return `Job move info updated - Move date changed to ${log.data.new_move_date}`;
      }

      if (update === 'arrival_window') {
        return `Job move info updated - Arrival window changed to ${log.data.new_arrival_window}`;
      }

      return '';
    },
  },
};
</script>

<style scoped lang="scss">
.removed-movers-trucks {
  color: red;
  text-decoration: line-through;
}

.log-box {
  .mod-icon-minus {
    display: none;
  }
  .mod-icon-plus {
    display: block;
  }
}

.log-box[aria-expanded='true'] {
  .mod-icon-minus {
    display: block;
  }
  .mod-icon-plus {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobLogs.vue